import { render, staticRenderFns } from "./SelectClass.vue?vue&type=template&id=80806ebe"
import script from "./SelectClass.vue?vue&type=script&lang=js"
export * from "./SelectClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80806ebe')) {
      api.createRecord('80806ebe', component.options)
    } else {
      api.reload('80806ebe', component.options)
    }
    module.hot.accept("./SelectClass.vue?vue&type=template&id=80806ebe", function () {
      api.rerender('80806ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/widgets/SelectClass.vue"
export default component.exports